<template>
  <v-content>
    <v-alert :value="displayAlert" :color="alertType">{{alertMsg}}</v-alert>
    <v-container fluid>
      <v-row>
        
         <v-col cols="12" md="4">
          <v-card class="mx-auto" max-width="400" to="/engagement/profiles">
            <v-img class="white--text" height="200px" src="images/content-recs-icon.png" >
              <v-card-title class="align-end fill-height">Engagement Recommendations</v-card-title>
            </v-img>
            <v-card-actions>
              <v-btn text color="green" to="/engagement/profiles">Engage Recs</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";

export default {
  name: "Dashboard",
  data: () => ({
    alertMsg: "",
    alertType: "",
    displayAlert: false
  }),

  created: function() {
    let msgData = this.$route.query;
    //console.log("HERE IS THE CONFIRM DATA: ", confirmData);
    this.alertMsg = msgData.msg;
    this.alertType = msgData.msg_type;
    if (msgData.msg_show === true) {
      this.displayAlert = true;
    }
  },
  mounted() {}
};
</script>

<style scoped>
</style>